//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const Styles = makeStyles((theme) => ({
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
  dateInput: {
    width: "100%",
  },
  searchInputIcon: {
    cursor: "pointer",
  },
  topGrid: {
    // marginBottom: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  editIcon: {
    verticalAlign: "middle",
    cursor: "pointer",
  },
  greenBtn: {
    backgroundColor: "green",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  redBtn: {
    backgroundColor: "red",
    padding: "2px 12px",
    borderRadius: 20,
    color: "white",
    fontWeight: "bold",
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
    position: "absolute",
    right: -10,
    top: -15,
  },

  // Dialog
  dialogParentDiv: {
    padding: 25,
  },
  parentText: {
    fontSize: 25,
  },
  padding: {
    padding: "20px 0px",
  },
  parentTextIcon: {
    color: "#faae30",
    fontSize: 30,
  },
  parentText2: {
    // color: "#595959",
    fontSize: 20,
    textAlign: 'justify'
  },
  subParentText: {
    color: "#595959",
    fontSize: 18,
  },
  dialogInput: {
    width: "100%",
    margin: "20px 0px",
  },
  cancelBtn: {
    color: "#305698",
    backgroundColor: "#fff",
    border: "2px solid #305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
  },
  proceedBtnGrid: {
    textAlign: "right",
  },
  proceedBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    borderRadius: 10,
    fontSize: 20,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  updateDialogLoader: {
    textAlign: "center",
  },
  filterBtn: {
    marginLeft: 20,
    marginTop: 5,
  },
  filterCardDiv: {
    overflowX: "auto",
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: "100%",
    zIndex: 100,
    marginTop: "2%",
  },
  filterCardGridContainer: {
    padding: 15,
    height: "100%",
  },
  filterCardGrid: {
    // borderRight: "1px solid #707070",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    "@media (max-width: 600px)": {
      border: "none",
    },
  },
  filterCardHeadText: {
    fontWeight: "bold",
    fontSize: "1rem",
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
    width: "100%",
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#2F7CBD",
    backgroundColor: "#fff",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    marginTop: "7%",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#2F7CBD",
    fontSize: "0.875rem",
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 90,
    height: 40,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#2F7CBD",
    },
 
  },
  exportBtn: {
    color: "#fff",
    width: "80px",
    height: "35px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "segoe-ui",
    borderRadius: 5,
    backgroundColor: "#2F7CBD",
    border: "none",
    "@media (max-width: 600px)": {
      marginTop: "4rem",
    },
  },
}));
